/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { Box, Text, theme, Spacer, FlexContainer } from "@nordcloud/gnui";
import {
  CloudResourcesFilterByRangeFields,
  RangeFilterComparisonOperator,
} from "~/generated/graphql";
import { NameWithLink } from "~/components/Tables/cells/NameWithLink";
import { ROUTES } from "~/routing/routes";
import { useGetCloudResources } from "~/views/resources_v2/hooks";

export function UnallocatedResources() {
  const { count, loading } = useGetCloudResources({
    page: "1",
    limit: "1",
    filter: {
      rangeFilterBy: [
        {
          field: CloudResourcesFilterByRangeFields.Unassigned,
          operator: RangeFilterComparisonOperator.Eq,
        },
      ],
    },
  });

  return (
    <Box spacing="spacing02" boxStyle="lightGrey">
      <FlexContainer>
        <Spacer width="3rem" />
        <div>
          <NameWithLink
            name="Unallocated Resources"
            link={`${ROUTES.resourcesV2.index}?allocation=unassigned`}
          />
          <Text size="sm" marginBottom={0} color={theme.color.text.text02}>
            {loading ? "Loading..." : `${count} Resources`}
          </Text>
        </div>
      </FlexContainer>
    </Box>
  );
}
